import { create } from "zustand";
import { EMPTY_TALENT_FILTERS, type TobisTalent, type TobisTalentFilters, type TobisTalentSort } from "@/lib/tobis";

// Der Stand des Personen-Registers - dasselbe Prinzip wie tobis-register-store
// (Titel): ein Store statt useState, damit ein Zurueck von einer Personenseite
// nicht bei Seite 1 neu laedt. Kein Cursor/appendPage hier: die Personenliste
// blaettert nicht (siehe TobisTalentsPage, ein Fetch mit limit=100).
//
// Bewusst NICHT persistiert (localStorage) - derselbe Grund wie beim Titel-
// Register: der Bestand aendert sich mit jedem Ingest-Lauf, der Stand soll
// eine Sitzung ueberleben, nicht einen Neustart.

interface TobisTalentState {
  filters: TobisTalentFilters;
  sort: TobisTalentSort;
  talents: TobisTalent[];
  total: number | null;
  /** Ob `talents` zum aktuellen Filter- und Sortierstand gehoert - wie bei tobis-register-store die einzige Stelle, die "muss ich laden?" entscheidet. */
  loaded: boolean;

  setFilters: (next: TobisTalentFilters) => void;
  setSort: (next: TobisTalentSort) => void;
  setPage: (talents: TobisTalent[], total?: number | null) => void;
  markLoaded: () => void;
}

export const useTobisTalentStore = create<TobisTalentState>((set) => ({
  filters: EMPTY_TALENT_FILTERS,
  sort: "credits",
  talents: [],
  total: null,
  loaded: false,

  setFilters: (next) => set({ filters: next, loaded: false, talents: [], total: null }),
  setSort: (next) => set({ sort: next, loaded: false, talents: [], total: null }),

  setPage: (talents, total) => set({ talents, loaded: true, total: total ?? null }),
  markLoaded: () => set({ loaded: true }),
}));
